const UrlsUrl = (props) => {
  const url = props?.row?.original?.url || "-";

  return <span title={url}>{url}</span>;
};

export default UrlsUrl;
